exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sau-dot.overdue {\n  background-color: #d8534f;\n}\n", ""]);

// exports
